import React from 'react';

import { IBodyCopyFields } from '../../../types/contentful';

import RichText from '../RichText';
import { BlockContainer, Layout, Column } from '../Layout';

export function BodyCopy({ copy }: IBodyCopyFields) {
  return (
    <BlockContainer
      marginTop={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
      marginBottom={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
      data-blockid="bodyCopy"
      data-testid="bodyCopy"
    >
      <Layout>
        <Column size={{ 0: 11, tablet: 8 }} flexDirection="column">
          <RichText data={copy} />
        </Column>
      </Layout>
    </BlockContainer>
  );
}
